import { Component, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { GroupFullSchema } from "@/modules/InfoGroup/models/GroupFullSchema";
import { PhoneSchema } from "@/shared/models/PhoneSchema";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  INFO_GROUP_CONSTANTS,
  INFO_GROUP_EVENTS
} from "@/modules/InfoGroup/constants/InfoGroupConstants";
import {
  FORM_CONSTANTS,
  LOCAL_STORAGE,
  mergeFormVjsfModel,
  PHONE_TRANSLATIONS,
  VJSF_OPTIONS
} from "@/shared/constants/FormConstants";
import { PhonePayload } from "@/modules/InfoGroup/models/PhonePayload";
import { FormSchema } from "@/shared/models/FormSchema";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { FormRule } from "@/modules/FormTemplate/models/FormRule";
import { FieldSummary } from "@/modules/FormTemplate/models/FieldSummary";
import FormRulePreview from "./FormRulePreview/FormRulePreview.vue";
import FormSummaryPreview from "./FormSummaryPreview/FormSummaryPreview.vue";
import vueDebounce from "vue-debounce";
import ModalTemplate from "../ModalTemplate/ModalTemplate.vue";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { SplitFormSchemaByHtmlResult, Utils } from "@/shared/utils/utils";
import lodash from "lodash";
import HtmlRenderFieldsForm from "../HtmlRenderFieldsForm/HtmlRenderFieldsForm.vue";

Vue.use(vueDebounce, {
  defaultTime: "2000ms",
  listenTo: ["input", "click"]
});

Vue.use(Vuetify);
@Component({
  name: "FormModalViewer",
  components: {
    ModifVJsfInput,
    VuePhoneNumberInput,
    FormRulePreview,
    FormSummaryPreview,
    ModalTemplate,
    HtmlRenderFieldsForm
  }
})
export default class FormModalViewer extends Vue {
  @Prop() clearModel!: boolean;

  @Prop() schema!: GroupFullSchema | FormSchema;
  @Prop() formRules!: FormRule[];
  @Prop() formSummary!: FieldSummary[];

  @Prop() dialogPreview!: boolean;
  @Prop() phoneTypeList!: PhoneSchema[];
  @Prop() name!: string;
  @Prop() description!: string;
  @Prop() state!: string;
  @Prop() dateCreated!: string;
  @Prop() dateChanged!: string;
  @Prop() type!: string;
  @Prop() category!: string;
  @Prop() version!: string;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  @Prop() dataModel!: any;
  @Prop({ default: "" }) modalText!: string;
  @Prop() fromChatbot?: boolean;

  warningDialog = false;
  modelChanged = false;
  formulaValue = "";
  refresh = 0;

  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  switchClass = STYLE_CLASSES.SWITCH;
  btnClassPrimaryRound = STYLE_CLASSES.BASIC_ROUND_BTN;

  CLOSE_BTN = INFO_GROUP_CONSTANTS.BUTTON.CLOSE;
  STATE_TEXT = INFO_GROUP_CONSTANTS.LABEL.STATE;
  DATE_CREATED_TEXT = INFO_GROUP_CONSTANTS.LABEL.DATE_CREATED;
  DATE_CHANGED_TEXT = INFO_GROUP_CONSTANTS.LABEL.DATE_CHANGED;
  DESCRIPTION_TEXT = INFO_GROUP_CONSTANTS.LABEL.DESCRIPTION;
  MOBILE_PREVIEW = FORM_CONSTANTS.LABEL.MOBILE_PREVIEW;
  MOBILE_STYLE = FORM_CONSTANTS.MOBILE_STYLE;
  CATEGORY_TEXT = FORM_TEMP_CONSTANTS.FORM_LABEL.CATEGORY;
  TYPE_TEXT = FORM_TEMP_CONSTANTS.FORM_LABEL.TYPE;
  VERSION_TEXT = FORM_TEMP_CONSTANTS.FORM_LABEL.VERSION;
  OUTDATED = FORM_TEMP_CONSTANTS.MODAL.OUTDATED_TEMPLATE;

  countriesPreferredList = INFO_GROUP_CONSTANTS.PREFERRED_COUNTRIES;
  translations = PHONE_TRANSLATIONS;
  options = VJSF_OPTIONS;

  mobileView = false;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  model: any = {};
  validForm = false;
  defaultCountry = "";
  htmlSchema: FormSchema = {
    type: "object",
    allOf: []
  };
  htmlFieldsModel: any;
  separatedSchema: SplitFormSchemaByHtmlResult | undefined;
  vjsfSchema: FormSchema = {
    type: "object",
    allOf: []
  };

  onModifVJsfInput(next: Record<string, any>) {
    this.model = mergeFormVjsfModel(this.model, next);
  }

  mounted() {
    this.modalTextChanged();
    if (this.dataModel) {
      this.model = lodash.cloneDeep(this.dataModel);
    }
  }

  created() {
    this.defaultCountry = localStorage.getItem(LOCAL_STORAGE.COUNTRY) || "";
    window.addEventListener("resize", this.removeMobileSet);
    this.separatedSchema = Utils.splitFormSchemaByHtmlDisplay(this.schema);
    const { htmlFields, vjsfFields } = Utils.splitFormFieldsFromSchemas(
      this.dataModel as Record<string, unknown>,
      this.separatedSchema as SplitFormSchemaByHtmlResult
    );
    this.htmlFieldsModel = Object.assign({}, htmlFields);
    this.vjsfSchema = this.separatedSchema.vjsfSchema as FormSchema;
    this.htmlSchema = this.separatedSchema.htmlSchema as FormSchema;

    this.model = vjsfFields ? vjsfFields : Utils.initialModel(this.vjsfSchema);
  }

  destroyed() {
    window.removeEventListener("resize", this.removeMobileSet);
  }

  removeMobileSet() {
    if (window.innerWidth < 960 && this.mobileView) {
      this.mobileView = false;
      const prev = this.$refs.previewGroupDiv as HTMLDivElement;
      prev.clientWidth / 0.6;
    }
  }

  close() {
    this.mobileView = false;
    this.$emit(INFO_GROUP_EVENTS.CLOSE_MODAL_PREVIEW);
  }

  changeStyle() {
    if (this.mobileView) {
      const prev = this.$refs.previewGroupDiv as HTMLDivElement;
      const widthStyle = prev.clientWidth * 0.6;
      return this.MOBILE_STYLE + `${widthStyle}px;`;
    }
  }

  @Watch("dataModel", { deep: true })
  updateModel() {
    this.model = this.dataModel;
  }

  @Watch("clearModel")
  updateModelJsonSchema() {
    this.model = this.dataModel
      ? this.dataModel
      : Utils.initialModel(this.schema);
    this.refresh++;
  }

  onUpdate(payload: PhonePayload, index: number) {
    this.phoneTypeList[index].countryCode = payload.countryCode;
    this.phoneTypeList[index].countryCallingCode = payload.countryCallingCode;
    this.phoneTypeList[index].formattedNumber = payload.formattedNumber || "";
    this.phoneTypeList[index].isValid = payload.isValid;
  }

  validateRequired(index: number): string {
    if (
      this.phoneTypeList[index].required == true &&
      !this.phoneTypeList[index].model
    ) {
      return "red";
    } else {
      return "#0B3352";
    }
  }

  reloadData() {
    if (!(this.schema instanceof GroupFullSchema)) {
      const items = this.schema.fields ? this.schema.fields : [];
      const conditions = this.schema.conditions ? this.schema.conditions : [];

      items.forEach(field => {
        if (
          field.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.FORMULA &&
          field.formula
        ) {
          this.formulaValue = field.formula.repeat(1);
          let fields = this.formulaValue.match(/\b[0-9A-Za-z_.-]{10}\b/g);

          if (fields != null) {
            const uniqueSet = new Set(fields);
            fields = JSON.parse(JSON.stringify([...uniqueSet]));

            fields!.forEach(fieldString => {
              if (fieldString in this.model) {
                let newValue = "";
                let score;

                const existList = items.find(
                  item =>
                    item.key === fieldString &&
                    item.type === FORM_TEMP_CONSTANTS.FIELD_TYPE.LIST
                );

                if (existList != undefined) {
                  if (existList.options) {
                    score =
                      existList.options.find(
                        item => item.value === this.model[fieldString]
                      )?.score ?? undefined;
                  } else {
                    score =
                      existList.schema.oneOf?.find(
                        item => item.const === this.model[fieldString]
                      )?.score ?? undefined;
                  }
                }
                if ((score && Number(score)) || score == 0) {
                  newValue = score.toString();
                } else {
                  newValue = this.model[fieldString];
                }

                const regExp = new RegExp(fieldString, "g");
                this.formulaValue = this.formulaValue.replace(
                  regExp,
                  `${newValue}`
                );
              }
            });

            try {
              const result = eval(this.formulaValue);
              if (result && isFinite(result)) {
                Vue.set(this.model, field.key, result.toString());
                this.modelChanged = true;
              }
            } catch (e) {
              delete this.model[field.key];
            }
          }
        }
      });

      conditions.forEach(condition => {
        if (condition.isArray && this.model[condition.key] != undefined) {
          this.model[condition.key].sort();
          this.modelChanged = true;
        }
      });

      if (this.modelChanged) {
        this.refresh = 1 - this.refresh;
        this.modelChanged = false;
      }
    }
  }

  @Watch("dialogPreview")
  modalTextChanged() {
    if (this.dialogPreview && this.modalText.length > 0) {
      this.warningDialog = true;
    }
  }

  handleModalAccept() {
    this.warningDialog = false;
  }
}
